const initialState = {
  activeQuestion: {},
  editingQuestion: null,
  questionToDelete: null,
  task: {},
  survey: {},
  quiz: {},
  indicatorId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'ACTIVITY_TASK/SET_INDICATOR_ID':
      return {
        ...state,
        indicatorId: action.indicatorId,
      };
    case 'ACTIVITY_TASK/SET_QUESTION_DETAILS':
      return {
        ...state,
        activeQuestion: {
          ...state.activeQuestion,
          ...action.activeQuestion,
        },
      };
    case 'ACTIVITY_TASK/REMOVE_UNSAVED_QUESTION': {
      return {
        ...state,
        activeQuestion: null,
      };
    }
    case 'ACTIVITY_TASK/SET_QUESTION_TO_DELETE':
      return {
        ...state,
        questionToDelete: action.questionId,
      };
    case 'ACTIVITY_TASK/REORDER_QUESTIONS': {
      return {
        ...state,
        survey: {
          ...state.survey,
          questions: action.newOrder,
        },
      };
    }
    case 'ACTIVITY_TASK/POPULATE_ACTIVITY_TASK':
      return {
        ...state,
        task: action.task,
      };
    case 'ACTIVITY_TASK/POPULATE_SURVEY':
      return {
        ...state,
        survey: action.survey,
      };
    case 'ACTIVITY_TASK/POPULATE_SAVED_QUESTION_DETAILS': {
      const savedQuestionIndex = state.survey.questions.findIndex(
        ({ uuid }) => action.question.uuid === uuid,
      );
      const replaceSavedQuestion = savedQuestionIndex !== -1;
      return {
        ...state,
        activeQuestion: null,
        editingQuestion: null,
        survey: {
          ...state.survey,
          questions: replaceSavedQuestion
            ? [
                ...state.survey.questions.slice(0, savedQuestionIndex),
                action.question,
                ...state.survey.questions.slice(savedQuestionIndex + 1),
              ]
            : [...state.survey.questions, action.question],
        },
      };
    }
    case 'ACTIVITY_TASK/SET_EDITING_QUESTION':
      return {
        ...state,
        editingQuestion: action.questionId,
      };
    case 'ACTIVITY_TASK/REMOVE_QUESTION_FROM_SURVEY':
      return {
        ...state,
        survey: {
          ...state.survey,
          questions: state.survey.questions.filter(
            q => q.uuid !== action.questionId,
          ),
        },
      };
    case 'ACTIVITY_TASK/POPULATE_QUIZ':
      return {
        ...state,
        quiz: action.quiz,
      };
    case 'ACTIVITY_TASK/POPULATE_SAVED_QUIZ_QUESTION_DETAILS': {
      const savedQuestionIndex = state.quiz.questions.findIndex(
        ({ uuid }) => action.question.uuid === uuid,
      );
      const replaceSavedQuestion = savedQuestionIndex !== -1;
      return {
        ...state,
        activeQuestion: null,
        editingQuestion: null,
        quiz: {
          ...state.quiz,
          questions: replaceSavedQuestion
            ? [
                ...state.quiz.questions.slice(0, savedQuestionIndex),
                action.question,
                ...state.quiz.questions.slice(savedQuestionIndex + 1),
              ]
            : [...state.quiz.questions, action.question],
        },
      };
    }
    case 'ACTIVITY_TASK/REMOVE_QUIZ_QUESTION_FROM_SURVEY':
      return {
        ...state,
        quiz: {
          ...state.quiz,
          questions: state.quiz.questions.filter(
            q => q.uuid !== action.questionId,
          ),
        },
      };
    case 'ACTIVITY_TASK/REORDER_QUIZ_QUESTIONS': {
      return {
        ...state,
        quiz: {
          ...state.quiz,
          questions: action.newOrder,
        },
      };
    }
    case 'ACTIVITY_TASK/REMOVE_DELETED_TASK':
      return {
        ...state,
        task: {
          ...state.task,
          elements: state.task.elements.filter(
            ({ uuid, objectId }) =>
              uuid !== action.id && objectId !== action.id,
          ),
        },
      };
    case 'ACTIVITY_TASK/EMPTY_SURVEY':
      return {
        ...state,
        survey: {},
      };
    case 'ACTIVITY_TASK/EMPTY_QUIZ':
      return {
        ...state,
        quiz: {},
      };
    case 'ACTIVITY_TASK/SET_NEW_ELEMENT_ORDER':
      return {
        ...state,
        task: {
          ...state.task,
          elements: action.newOrder,
        },
      };
    default:
      return state;
  }
};
